import { SHStack, SHTypography } from "@components/design-systems";
import { CheckSVG, WarningSVG } from "@components/svgs";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { useTheme } from "@mui/material";
import { memo } from "react";

interface WarningCellProps {
  analysisData?: MAAnalysisDataDTO;
}
export const WarningCell = memo(({ analysisData }: WarningCellProps) => {
  const { value } = analysisData || {};
  const { palette } = useTheme();

  if (value === ManagedAccountFieldTypeValue.NoBreach) {
    return <CheckSVG />;
  }

  if (value === "-") {
    return (
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        {value}
      </SHTypography>
    );
  }

  return (
    <SHStack direction="row" spacing={1} justifyContent="center">
      <SHStack mt={"1px"}>
        <WarningSVG backgroundColor={palette.error[200]} iconColor="white" />
      </SHStack>
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        Breach
      </SHTypography>
    </SHStack>
  );
});
